import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const inputFn = /* @__PURE__ */ createRecipe('Input', {
  "variant": "outlined",
  "size": "md"
}, [
  {
    "size": "sm",
    "isRounded": true,
    "css": {
      "root": {
        "--input-padding": "spacing.md"
      }
    }
  },
  {
    "size": "md",
    "isRounded": true,
    "css": {
      "root": {
        "--input-padding": "spacing.lg"
      }
    }
  },
  {
    "size": "lg",
    "isRounded": true,
    "css": {
      "root": {
        "--input-padding": "spacing.xl"
      }
    }
  },
  {
    "size": "sm",
    "isRounded": true,
    "css": {
      "root": {
        "--input-padding": "spacing.md"
      }
    }
  }
])

const inputVariantMap = {
  "variant": [
    "outlined",
    "filled",
    "ghost"
  ],
  "size": [
    "sm",
    "md",
    "lg"
  ],
  "isRounded": [
    "true"
  ]
}

const inputVariantKeys = Object.keys(inputVariantMap)

export const input = /* @__PURE__ */ Object.assign(memo(inputFn.recipeFn), {
  __recipe__: true,
  __name__: 'input',
  __getCompoundVariantCss__: inputFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: inputVariantKeys,
  variantMap: inputVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, inputVariantKeys)
  },
  getVariantProps: inputFn.getVariantProps,
})